import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "../../config/URL";
import fetchAllCentersWithIds from "../List/CenterList";
import fetchAllSubjectsWithIds from "../List/SubjectList";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import ArrangeAssesmentAdd from "./ArrangeAssesmentAdd";
import ArrangeAssesmentEdit from "./ArrangeAssesmentEdit";
import GlobalDelete from "../../components/common/GlobalDelete";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import {
  ThemeProvider,
  createTheme,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import { exportVisibleColumnsToCSV } from "../../components/common/ExportCsv";
import {
  getColumnPreference,
  saveColumnPreference,
} from "../../utility/mrtColumnPersistence";

const MODULE_KEY = "LEAD";

const Lead = ({ selectedCenter, fetchLeadCounts }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const lead_status = state?.leadStatus || "";
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const [activeButton, setActiveButton] = useState("All");
  const storedScreens = JSON.parse(localStorage.getItem("screens") || {});

  const canIndex = Boolean(storedScreens?.leadListingIndex);
  const canRead = Boolean(storedScreens?.leadListingRead);
  const canCreate = Boolean(storedScreens?.leadListingCreate);
  const canUpdate = Boolean(storedScreens?.leadListingUpdate);
  const canDelete = Boolean(storedScreens?.leadListingDelete);
  const showActionColumn = canUpdate || canDelete;

  const centerLocalId = localStorage.getItem("selectedCenterId");
  const [centerData, setCenterData] = useState(null);
  const [subjectData, setSubjectData] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isClearFilterClicked, setIsClearFilterClicked] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [filters, setFilters] = useState({
    centerId: selectedCenter,
    subjectId: "",
    leadStatus: "ALL",
  });

  const defaultColumnVisibility = {
    address: false,
    createdBy: false,
    createdAt: false,
    updatedBy: false,
    updatedAt: false,
  };

  const [columnVisibility, setColumnVisibility] = useState(() =>
    getColumnPreference(MODULE_KEY, defaultColumnVisibility),
  );

  const handleShow = () => {
    setShowDialog(true);
  };
  const handleClose = () => {
    setShowDialog(false);
  };
  const handleEditShowDialog = () => {
    setShowEditDialog(true);
  };
  const handleEditCloseDialog = () => {
    setShowEditDialog(false);
    // formik.resetForm();
  };

  /* -------------------- FETCH CENTER & SUBJECT -------------------- */
  const fetchCenterData = async () => {
    try {
      const centerData = await fetchAllCentersWithIds();
      const subjectDatas = await fetchAllSubjectsWithIds();

      if (centerLocalId !== null && centerLocalId !== "undefined") {
        setFilters((prevFilters) => ({
          ...prevFilters,
          centerId: centerLocalId,
        }));
      } else if (centerData !== null && centerData.length > 0) {
        setFilters((prevFilters) => ({
          ...prevFilters,
          centerId: centerData[0].id,
        }));
      }
      setCenterData(centerData);
      setSubjectData(subjectDatas);
    } catch (error) {
      toast.error(error);
    }
  };

  /* -------------------- FETCH LEAD DATA -------------------- */
  const getData = async () => {
    setLoading(true);
    let params = {};

    // Use centerLocalId or a default centerId when filters are cleared, unless centerId is explicitly "0"
    const centerId =
      filters.centerId ||
      (centerLocalId && centerLocalId !== "undefined"
        ? centerLocalId
        : centerData?.[0]?.id || "");

    // Only add centerId to params if it's not "0"
    if (centerId !== "" && centerId !== "0") {
      params.centerId = centerId;
    }

    // Add subjectId to params if it exists
    if (filters.subjectId !== "") {
      params.subjectId = filters.subjectId;
    }

    // Add leadStatus to params if it's not "ALL"
    if (filters.leadStatus !== "" && filters.leadStatus !== "ALL") {
      params.leadStatus = filters.leadStatus;
    }

    try {
      // If centerId is "0", params will be empty or only contain other filters
      const response = await api.get("/getAllLeadInfos", { params });
      setDatas(response.data);
      setActiveButton(
        filters.leadStatus === "ALL"
          ? "All"
          : [
              { displayName: "New / Waitlist", backendName: "NEW_WAITLIST" },
              {
                displayName: "Assessment Arranged",
                backendName: "ARRANGING_ASSESSMENT",
              },
              { displayName: "KIV", backendName: "KIV" },
              {
                displayName: "Waiting for Payment",
                backendName: "WAITING_FOR_PAYMENT",
              },
              { displayName: "Confirmed", backendName: "CONFIRMED" },
              {
                displayName: "Assessment Done",
                backendName: "ASSESSMENT_DONE",
              },
              { displayName: "Enrolled", backendName: "ENROLLED" },
              { displayName: "Drop", backendName: "DROP" },
              { displayName: "All", backendName: "ALL" },
            ].find((status) => status.backendName === filters.leadStatus)
              ?.displayName || "All",
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      setIsClearFilterClicked(false);
    }
  };

  const handleStatusChange = async (row, status) => {
    setSelectedRow(row);
    let message = "Are you sure want to change the lead status?";
    if (status === "DROP") {
      message = "Are you sure want to drop this lead?";
      setConfirmationMessage(message);
      setShowModal(true);
    } else if (status === "KIV") {
      message = "Are you sure want to KIV this lead?";
      setConfirmationMessage(message);
      setShowModal(true);
    } else if (status === "NEW_WAITLIST") {
      message = "Are you sure want to make this lead New/Waitlist?";
      console.log("object", selectedRow);
      setConfirmationMessage(message);
      setShowModal(true);
    } else if (status === "WAITING_FOR_PAYMENT") {
      message = "Are you sure want to mark this lead as Waiting For Payment?";
      setConfirmationMessage(message);
      setShowModal(true);
    } else if (status === "ARRANGING_ASSESSMENT") {
      console.log("object", selectedRow);
      handleShow();
    } else if (status === "CONFIRMED") {
      navigate(`/student/add?LeadId=${row.id}&LeadStatus=CONFIRMED`);
    } else if (status === "Do_Assessment") {
      navigate(`/lead/lead/assessment/${row.id}`);
    } else if (status === "EDIT_DO_ASSESSMENT") {
      navigate(`/lead/lead/assessment/${row.id}?mode=edit`);
    } else if (status === "ENROLLED") {
      navigate(`/student/add?LeadId=${row.id}&LeadStatus=ENROLLED`);
    } else if (status === "Assessment_Edit") {
      handleEditShowDialog();
    }

    setNewStatus(status);
    setSelectedId(row.id);
  };

  const handleFormSubmit = async () => {
    try {
      const response = await api.put(`/updateLeadInfo/${selectedId}`, {
        leadStatus: newStatus,
      });

      if (response.status === 200) {
        toast.success("Lead Status Updated");
        setShowModal(false);
        ResetFilter();
        getData();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error.message || "An error occurred");
    }
  };

  const handleClick = async (selectedId) => {
    try {
      const response = await api.put(`/updateLeadInfo/${selectedId}`, {
        isNew: false,
      });
      if (response.status === 200) {
        getData();
        fetchLeadCounts();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error.message || "An error occurred");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchCenterData(); // Fetch center data and subjects

      // Check if local storage has center ID
      if (centerLocalId && centerLocalId !== "undefined") {
        setFilters((prevFilters) => ({
          ...prevFilters,
          centerId: selectedCenter,
        }));
      } else if (centerData && centerData.length > 0) {
        // Use the first center's ID as the default if no center is in local storage
        setFilters((prevFilters) => ({
          ...prevFilters,
          centerId: selectedCenter,
        }));
      }
    };
    fetchData();
  }, [selectedCenter]);

  useEffect(() => {
    if (centerData) getData();
  }, [filters]);

  useEffect(() => {
    if (centerData) {
      // Ensure centerData is available before fetching
      getData();
    }
  }, [filters]);

  useEffect(() => {
    if (lead_status) {
      setFilters((prev) => ({
        ...prev,
        leadStatus: lead_status,
      }));
    }
  }, [lead_status]);

  const ResetFilter = () => {
    setFilters({
      centerId: selectedCenter,
      subjectId: "",
      leadStatus: "",
    });
    // getData();
    setIsClearFilterClicked(true);
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 736);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  /* -------------------- COLUMNS -------------------- */
  const columns = useMemo(() => {
    const baseColumns = [
      {
        accessorFn: (row, index) => index + 1,
        header: "S.NO",
        size: 20,
        Cell: ({ cell }) => (
          <span style={{ textAlign: "center" }}>{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "leadStatus",
        enableHiding: true,
        header: "Status",
        Cell: ({ row }) => (
          <div className="d-flex justify-content-start">
            {row.original.leadStatus === "CONFIRMED" ? (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className={`btn btn-sm px-1 py-1 leadStatus text-bg-success`}
                type="button"
              >
                <span
                  className="text-white"
                  style={{
                    textDecoration: "none",
                    cursor: "default",
                  }}
                >
                  Confirmed
                </span>
              </button>
            ) : row.original.leadStatus === "ENROLLED" ? (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className={`btn btn-sm px-1 py-1 leadStatus text-bg-success`}
                type="button"
                style={{ cursor: "default" }}
              >
                <span className="text-white" style={{ textWrap: "nowrap" }}>
                  Enrolled
                </span>
              </button>
            ) : (
              <select
                value={row.original.leadStatus}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  handleStatusChange(row.original, e.target.value);
                }}
                className="d-flex form-control justify-content-center"
                style={{
                  padding: "0px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  appearance: "none",
                  textIndent: "20px",
                  color: "#fff",
                  cursor: "pointer",
                  fontSize: "10px",
                  backgroundColor: `${
                    row.original.leadStatus === "NEW_WAITLIST"
                      ? "#0d6efd"
                      : row.original.leadStatus === "KIV"
                        ? "#6c757d"
                        : row.original.leadStatus === "WAITING_FOR_PAYMENT"
                          ? "#0d6efd"
                          : row.original.leadStatus === "ARRANGING_ASSESSMENT"
                            ? "#ffd107"
                            : row.original.leadStatus === "ASSESSMENT_DONE"
                              ? "#0dcaf0"
                              : row.original.leadStatus === "DROP"
                                ? "#c42d33"
                                : ""
                  }`,
                  textAlign: "center",
                  textIndent: "0",
                  lineHeight: "20px",
                  maxWidth: "max-content",
                }}
              >
                {row.original.leadStatus === ("NEW_WAITLIST" || "DROP") ? (
                  <>
                    <option
                      value="NEW_WAITLIST"
                      hidden
                      disabled={row.original.leadStatus === "NEW_WAITLIST"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      New / Waitlist
                    </option>
                    <option
                      value="ARRANGING_ASSESSMENT"
                      style={{
                        backgroundColor: "white",
                        padding: "10px 15px ",
                        color: "#000",
                        cursor: "pointer",
                      }}
                    >
                      Assessment Add
                    </option>
                    <option
                      value="KIV"
                      disabled={row.original.leadStatus === "KIV"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      KIV
                    </option>
                    <option
                      value="WAITING_FOR_PAYMENT"
                      disabled={
                        row.original.leadStatus === "WAITING_FOR_PAYMENT"
                      }
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Waiting for Payment
                    </option>
                    <option
                      value="CONFIRMED"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Confirmed
                    </option>
                    <option
                      value="DROP"
                      disabled={row.original.leadStatus === "DROP"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Drop
                    </option>
                  </>
                ) : row.original.leadStatus === "ARRANGING_ASSESSMENT" ? (
                  <>
                    <option
                      value="ARRANGING_ASSESSMENT"
                      hidden
                      disabled={
                        row.original.leadStatus === "ARRANGING_ASSESSMENT"
                      }
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Assessment Arranged
                    </option>
                    <option
                      value="NEW_WAITLIST"
                      disabled={row.original.leadStatus === "NEW_WAITLIST"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      New / Waitlist
                    </option>

                    <option
                      value="Do_Assessment"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Do Assessment
                    </option>

                    <option
                      value="Assessment_Edit"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Assessment Edit
                    </option>
                    <option
                      value="DROP"
                      disabled={row.original.leadStatus === "DROP"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Drop
                    </option>
                  </>
                ) : row.original.leadStatus === "KIV" ? (
                  <>
                    <option
                      value="KIV"
                      hidden
                      disabled={row.original.leadStatus === "KIV"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      KIV
                    </option>
                    <option
                      value="NEW_WAITLIST"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      New / Waitlist
                    </option>
                    <option
                      value="ARRANGING_ASSESSMENT"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Assessment Add
                    </option>
                    <option
                      value="WAITING_FOR_PAYMENT"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Waiting For Payment
                    </option>
                    <option
                      value="CONFIRMED"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Confirmed
                    </option>
                    <option
                      value="DROP"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Drop
                    </option>
                  </>
                ) : row.original.leadStatus === "ASSESSMENT_DONE" ? (
                  <>
                    <option
                      value="ASSESSMENT_DONE"
                      hidden
                      disabled={row.original.leadStatus === "ASSESSMENT_DONE"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Assessment Done
                    </option>
                    <option
                      value="NEW_WAITLIST"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      New / Waitlist
                    </option>
                    <option
                      value="EDIT_DO_ASSESSMENT"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Edit Do Assessment
                    </option>
                    <option
                      value="KIV"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      KIV
                    </option>
                    <option
                      value="ENROLLED"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Enrolled
                    </option>
                    <option
                      value="DROP"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Drop
                    </option>
                  </>
                ) : row.original.leadStatus === "WAITING_FOR_PAYMENT" ? (
                  <>
                    <option
                      value="WAITING_FOR_PAYMENT"
                      hidden
                      disabled={
                        row.original.leadStatus === "WAITING_FOR_PAYMENT"
                      }
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Waiting For Payment
                    </option>
                    <option
                      value="NEW_WAITLIST"
                      disabled={row.original.leadStatus === "NEW_WAITLIST"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      New / Waitlist
                    </option>
                    <option
                      value="ARRANGING_ASSESSMENT"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Assessment Add
                    </option>
                    <option
                      value="KIV"
                      disabled={row.original.leadStatus === "KIV"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      KIV
                    </option>
                    <option
                      value="CONFIRMED"
                      disabled={row.original.leadStatus === "CONFIRMED"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Confirmed
                    </option>
                    <option
                      value="DROP"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Drop
                    </option>
                  </>
                ) : (
                  <>
                    <option
                      value="NEW_WAITLIST"
                      disabled={row.original.leadStatus === "NEW_WAITLIST"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      New / Waitlist
                    </option>
                    <option
                      value="ARRANGING_ASSESSMENT"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Assessment Add
                    </option>
                    <option
                      value="KIV"
                      disabled={row.original.leadStatus === "KIV"}
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      KIV
                    </option>
                    <option
                      value="WAITING_FOR_PAYMENT"
                      disabled={
                        row.original.leadStatus === "WAITING_FOR_PAYMENT"
                      }
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Waiting for Payment
                    </option>
                    <option
                      value="CONFIRMED"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Confirmed
                    </option>
                    <option
                      value="DROP"
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#000",
                      }}
                    >
                      Drop
                    </option>
                  </>
                )}
              </select>
            )}
          </div>
        ),
      },
      {
        accessorKey: "studentName",
        enableHiding: false,
        header: "Student Name",
        size: 60,
        Cell: ({ row }) => (
          <>
            <div className="d-flex justify-content-start align-items-center">
              {row.original.studentName} &nbsp;&nbsp;
              {row.original.isNew && (
                <div className="newCircle">
                  <span className="badge text-bg-danger">New</span>
                </div>
              )}
            </div>
          </>
        ),
      },
       {
        header: "Email",
        accessorKey: "fathersEmailAddress",
        enableHiding: true,
        cell: ({ cell }) => <span>{cell.getValue()}</span>,
      },
       {
        header: "Phone",
        accessorKey: "fathersMobileNumber",
        enableHiding: true,
        cell: ({ cell }) => <span>{cell.getValue()}</span>,
      },
      {
        header: "Centre Name",
        accessorKey: "center",
        enableHiding: true,
        cell: ({ cell }) => <span>{cell.getValue()}</span>,
      },
      {
        accessorKey: "dateOfBirth",
        header: "Date Of Birth",
        Cell: ({ cell }) =>
          cell.getValue()?.substring(0, 10)?.split("").join(""),
      },
      {
        header: "Subject",
        accessorKey: "subject",
        enableHiding: true,
      },
      {
        accessorKey: "fathersFullName",
        header: "Parent Name",
      },
      { accessorKey: "address", header: "Address" },
      {
        accessorKey: "createdBy",
        header: "Created By",
        Cell: ({ cell }) => cell.getValue() || "",
      },
      {
        accessorKey: "createdAt",
        header: "Created On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10),
      },
      {
        accessorKey: "updatedAt",
        header: "Updated On",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10) || "",
      },
      {
        accessorKey: "updatedBy",
        header: "Updated By",
        Cell: ({ cell }) => cell.getValue() || "",
      },
    ];

    if (!showActionColumn) return baseColumns;

    const actionColumn = {
      id: "actions",
      header: "",
      size: 20,
      enableSorting: false,
      Cell: ({ row }) => (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setMenuAnchor(e.currentTarget);
            setSelectedId(row.original.id);
          }}
        >
          <MoreVertIcon />
        </IconButton>
      ),
    };

    // ✅ Action column ALWAYS second
    return [baseColumns[0], actionColumn, ...baseColumns.slice(1)];
  }, [showActionColumn]);

  /* -------------------- TABLE INSTANCE -------------------- */
  const table = useMaterialReactTable({
    columns,
    data: datas,
    state: {
      columnVisibility,
    },
    onColumnVisibilityChange: (updater) => {
      const newVisibility =
        typeof updater === "function" ? updater(columnVisibility) : updater;

      setColumnVisibility(newVisibility);
      saveColumnPreference(MODULE_KEY, newVisibility);
    },

    enableColumnActions: true,
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    initialState: {
      pagination: { pageSize: 50, pageIndex: 0 },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <button
        className="btn btn-sm btn-border"
        onClick={() => exportVisibleColumnsToCSV(table, datas, "LeadList.csv")}
      >
        Export CSV
      </button>
    ),
    muiTableBodyRowProps: ({ row }) => ({
      onClick: canRead
        ? () => navigate(`/lead/lead/view/${row.original.id}`)
        : undefined,
      style: { cursor: canRead ? "pointer" : "default" },
    }),
  });

  /* -------------------- THEME -------------------- */
  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#535454 !important",
            backgroundColor: "#e6edf7 !important",
            fontWeight: "400 !important",
            fontSize: "13px !important",
            textAlign: "center !important",
          },
        },
      },
    },
  });

  const handleMenuClose = () => setMenuAnchor(null);

  return (
    <div className="container-fluid center my-4">
      <ol
        className="breadcrumb my-3"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        <li>
          <Link to="/" className="custom-breadcrumb">
            Home
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          &nbsp;Lead Management
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li className="active breadcrumb-item" aria-current="page">
          &nbsp;Lead Listing
        </li>
      </ol>

      <div className="row mb-3">
        <div className="col-12 d-flex flex-wrap justify-content-center">
          <div
            className={`btn-group bg-light ${
              isSmallScreen ? "btn-group-vertical" : ""
            }`}
            role="group"
            aria-label="Status buttons"
          >
            {[
              {
                displayName: "New / Waitlist",
                backendName: "NEW_WAITLIST",
              },
              {
                displayName: "Assessment Arranged",
                backendName: "ARRANGING_ASSESSMENT",
              },
              { displayName: "KIV", backendName: "KIV" },
              {
                displayName: "Waiting for Payment",
                backendName: "WAITING_FOR_PAYMENT",
              },
              { displayName: "Confirmed", backendName: "CONFIRMED" },
              {
                displayName: "Assessment Done",
                backendName: "ASSESSMENT_DONE",
              },
              { displayName: "Enrolled", backendName: "ENROLLED" },
              { displayName: "Drop", backendName: "DROP" },
              { displayName: "All", backendName: "ALL" },
            ].map((status, index) => (
              <button
                key={index}
                type="button"
                className={`btn btn-white status-txt ${
                  activeButton === status.displayName ? "active" : ""
                }`}
                onClick={() => {
                  setFilters((pre) => ({
                    ...pre,
                    leadStatus: status.backendName,
                  }));
                  setActiveButton(status.displayName);
                }}
              >
                {status.displayName}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="card">
        <div
          className="d-flex align-items-center justify-content-between p-1 mb-3"
          style={{ background: "#f5f7f9" }}
        >
          <div className="d-flex align-items-center">
            <div className="d-flex">
              <div className="active dot"></div>
            </div>
            <span className="text-muted me-2">
              This database shows the list of{" "}
              <span className="bold" style={{ color: "#287f71" }}>
                Lead
              </span>
            </span>
          </div>
        </div>
        <div className="d-flex justify-content-between mb-3 px-2">
          <div className="d-lg-flex individual_fliters">
            <div className="form-group mb-0 mb-1 ms-2">
              <input type="hidden" name="centerId" value={filters.centerId} />
            </div>
            <div className="form-group mb-0 mb-1">
              <select
                className="form-select form-select-sm mb-2 mb-md-0"
                name="subjectId"
                value={filters.subjectId}
                onChange={(e) =>
                  setFilters((pre) => ({ ...pre, subjectId: e.target.value }))
                }
              >
                <option value="" disabled selected>
                  Select Subject
                </option>
                {subjectData &&
                  subjectData.map((subject) => (
                    <option key={subject.id} value={subject.id}>
                      {subject.subjects}
                    </option>
                  ))}
              </select>
            </div>

            <div className="form-group mb-0 mb-1 ms-2">
              <button
                type="button"
                className="btn btn-sm border-secondary ms-3"
                onClick={ResetFilter}
              >
                Clear
              </button>
            </div>
          </div>
          {canCreate && (
            <Link to="/lead/lead/add">
              <button
                type="button"
                className="btn btn-button btn-sm me-2"
                style={{ fontWeight: "600px !important" }}
              >
                &nbsp; Add &nbsp;&nbsp; <i className="bx bx-plus"></i>
              </button>
            </Link>
          )}
        </div>
        {loading ? (
          <div className="loader-container">
            <div className="loading">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          <>
            <ThemeProvider theme={theme}>
              <MaterialReactTable table={table} />
            </ThemeProvider>

            <Menu
              id="action-menu"
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleMenuClose}
            >
              {/* <MenuItem
                    onClick={() => navigate(`/lead/lead/view/${selectedId}`)}
                  >
                    View
                  </MenuItem> */}
              {canUpdate && (
                <MenuItem
                  onClick={() => {
                    navigate(`/lead/lead/edit/${selectedId}`);
                    handleClick(selectedId);
                  }}
                  className="text-start mb-0 menuitem-style"
                >
                  Edit
                </MenuItem>
              )}
              {canDelete && (
                <MenuItem>
                  <GlobalDelete
                    path={`/deleteLeadInfo/${selectedId}`}
                    onDeleteSuccess={getData}
                    onOpen={handleMenuClose}
                  />
                </MenuItem>
              )}
            </Menu>
          </>
        )}
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="headColor">
            Change Leads Status Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-start">
            <p>{confirmationMessage}</p>
            <div className="d-flex align-items-center justify-content-between">
              <button
                className="btn btn-border btn-sm bg-light text-dark"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button
                style={{ background: "#eb862a" }}
                className="btn btn-sm text-white"
                onClick={handleFormSubmit}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ArrangeAssesmentAdd
        leadId={selectedRow.id}
        onSuccess={getData}
        centerId={selectedRow.centerId}
        centerName={selectedRow.center}
        studentNames={selectedRow.studentName}
        setAll={ResetFilter}
        showDialog={showDialog}
        handleShow={handleShow}
        handleClose={handleClose}
        centerDatas={centerData}
      />
      <ArrangeAssesmentEdit
        leadId={selectedRow.id}
        arrangeAssesmentId={
          selectedRow?.assessmentArrange?.length > 0
            ? selectedRow?.assessmentArrange[0]?.id
            : 0
        }
        onSuccess={getData}
        centerId={selectedRow.centerId}
        studentNames={selectedRow.studentName}
        setAll={ResetFilter}
        showDialog={showEditDialog}
        handleShow={handleEditShowDialog}
        handleClose={handleEditCloseDialog}
        centerDatas={centerData}
      />
    </div>
  );
};

export default Lead;
